export const FARB_VORSCHLAEGE: readonly string[] = ['#2C5591', '#B45309', '#0F766E', '#1B6E8C', '#BE123C', '#33312E'];
